<template>
  <div class="modal-goodsAdd">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">添加积分商品</div>
        <button type="button" class="btn-close" @click="closeSelf">关闭</button>
      </div>
      <div class="modal-body" v-loading="loadingModal">

        <el-form :model="addForm" :rules="rules" ref="addForm">

          <el-row>
            <el-col :span="24" class="item">
              <el-steps :active="activeStep"  align-center>
                <el-step title="基本信息"></el-step>
                <el-step title="商品图片"></el-step>
                <el-step title="商品详情"></el-step>
                <el-step title="商品价格"></el-step>
              </el-steps>
            </el-col>
          </el-row>
          <div style="height: 10px"></div>
          <el-row>
            <el-col :span="24" class="item">
              <el-tabs v-model="tab"  tab-position="left" style="height: 400px;">
                <el-tab-pane label="基本信息">

                  <el-row>
                    <el-col :span="12" class="item">
                      <el-form-item label="商品名称" required prop="name">
                        <el-input v-model="addForm.name" placeholder="请输入名称"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12" class="item">
                      <el-form-item label="商品副标题">
                        <el-input v-model="addForm.nameMore" placeholder="请输入商品副标题"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="12" class="item">
                      <el-form-item label="政府商品分类"  required prop="goodsClassGovernmentCode">
                        <el-cascader v-model="addForm.goodsClassGovernmentCode"
                                     :options="goodsClassGovValue"
                                     :props="options" style="width:100%" @change="goodsClassGovChange"></el-cascader>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12" class="item">
                      <el-form-item label="商家商品分类">

                        <!--                                <el-cascader-->
                        <!--                                    v-model="addForm.goodsClassBusinessCode"-->
                        <!--                                    :options="goodsClassBusinessValue"-->
                        <!--                                    :props="options1" style="width:100%"></el-cascader>-->

                        <el-select v-model="addForm.goodsClassBusinessCode" style="width:100%">
                          <el-option
                              v-for="item in goodsClassBusinessValue"
                              :key="item.goodsClassBusinessCode"
                              :label="item.name"
                              :value="item.goodsClassBusinessCode">
                          </el-option>
                        </el-select>

                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="12" class="item">
                      <el-form-item label="商品类型" required prop="goodsType">
                        <el-select v-model="addForm.goodsType" style="width:100%">
                          <el-option
                              v-for="item in goodsTypeValue"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12" class="item">
                      <el-form-item label="是否推荐" required prop="isRecommend">
                        <el-radio-group v-model="addForm.isRecommend" style="width:100%">
                          <el-radio :label="1">是</el-radio>
                          <el-radio :label="0">否</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="12" class="item">
                      <el-form-item label="是否特价" required prop="isBargainPrice">
                        <el-radio-group v-model="addForm.isBargainPrice" style="width:100%">
                          <el-radio :label="1">是</el-radio>
                          <el-radio :label="0">否</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <!--                    <el-col :span="12" class="item">-->
                    <!--                      <el-form-item label="是否APP显示">-->
                    <!--                        <el-radio-group v-model="addForm.isAPP" style="width:100%">-->
                    <!--                          <el-radio :label="1">是</el-radio>-->
                    <!--                          <el-radio :label="0">否</el-radio>-->
                    <!--                        </el-radio-group>-->
                    <!--                      </el-form-item>-->
                    <!--                    </el-col>-->
                  </el-row>

                  <!--                  <el-row>-->
                  <!--                    <el-col :span="12" class="item">-->
                  <!--                      <el-form-item label="是否收银机显示">-->
                  <!--                        <el-radio-group v-model="addForm.isPad" style="width:100%">-->
                  <!--                          <el-radio :label="1">是</el-radio>-->
                  <!--                          <el-radio :label="0">否</el-radio>-->
                  <!--                        </el-radio-group>-->
                  <!--                      </el-form-item>-->
                  <!--                    </el-col>-->
                  <!--                  </el-row>-->

                </el-tab-pane>

                <el-tab-pane label="商品图片" :disabled="disabledTab[1]">
                  <el-row>
                    <el-col :span="24" class="item">
                      <el-form-item label="商品轮播图" class="imgLabel" required>
                        <div style="float: left;margin-right: 10px;">
                          <el-upload class="avatar-uploader" action="ddd"
                                     list-type="picture-card" :before-upload="beforeUpload1">
                            <img v-if="addForm.head1" :src="addForm.head1" style="width: 78px;height: 78px;display: block;">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                          </el-upload>
                        </div>
                        <div style="float: left;margin-right: 10px;">
                          <el-upload class="avatar-uploader" action="ddd"
                                     list-type="picture-card" :before-upload="beforeUpload2">
                            <img v-if="addForm.head2" :src="addForm.head2" style="width: 78px;height: 78px;display: block;">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                          </el-upload>
                        </div>
                        <div style="float: left;margin-right: 10px;">
                          <el-upload class="avatar-uploader" action="ddd"
                                     list-type="picture-card" :before-upload="beforeUpload3">
                            <img v-if="addForm.head3" :src="addForm.head3" style="width: 78px;height: 78px;display: block;">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                          </el-upload>
                        </div>
                        <div style="float: left;margin-right: 10px;">
                          <el-upload class="avatar-uploader" action="ddd"
                                     list-type="picture-card" :before-upload="beforeUpload4">
                            <img v-if="addForm.head4" :src="addForm.head4" style="width: 78px;height: 78px;display: block;">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                          </el-upload>
                        </div>
                        <div style="float: left;margin-right: 10px;">
                          <el-upload class="avatar-uploader" action="ddd"
                                     list-type="picture-card" :before-upload="beforeUpload5">
                            <img v-if="addForm.head5" :src="addForm.head5" style="width: 78px;height: 78px;display: block;">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                          </el-upload>
                        </div>
                        <div style="float: left;margin-right: 10px;">
                          <div style="border: 1px solid #eee;border-radius: 5px;">
                            <i class="el-icon-close avatar-uploader-icon" @click="removeHead()"></i>
                          </div>
                        </div>
                        <div style="clear: both;"></div>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-tab-pane>
                <el-tab-pane label="商品详情" :disabled="disabledTab[2]">
                  <el-row>
                    <el-col :span="24" class="item">
                      <el-form-item label="商品详情" required>
                        <Quill placeholder='请输入详情' v-model='addForm.details' editorRef='addQuill' @input="handelIncrease"></Quill>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-tab-pane>
                <el-tab-pane label="商品价格" :disabled="disabledTab[3]" >
                  <el-col :span="12" class="item"  v-if='atrList.length==0'>
                    <el-form-item label="商品价格（元）" required>
                      <el-input v-model.trim="addForm.price" min="0"
                                onkeyup="this.value= this.value.match(/\d+(\.\d{0,2})?/) ? this.value.match(/\d+(\.\d{0,2})?/)[0] : ''" placeholder="请输商品价格"
                                type="number">
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" class="item"  v-if='atrList.length==0'>
                    <el-form-item label="商品库存" required>
                      <div style="margin-top:40px">
                        <el-input-number :precision='0' :min="0" v-model.trim="addForm.stock" ></el-input-number>
                      </div>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" class="item"  v-if='atrList.length==0'>
                    <el-form-item label="商品最小价格（元）" required>
                      <el-input v-model.trim="addForm.priceMin" min="0"
                                onkeyup="this.value= this.value.match(/\d+(\.\d{0,2})?/) ? this.value.match(/\d+(\.\d{0,2})?/)[0] : ''" placeholder="请输商品最低价格"
                                type="number">
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <div v-if='atrList.length>0'>
                    <el-col :span="24" class="item" v-for="(item,i) in atrList" :key='i' >
                      <el-form-item :label="item.name"  required>
                        <el-checkbox-group v-model="addForm.selectAtrValue[item.key]" @change="selectChangeAtr" style="margin-top: 40px;">
                          <el-checkbox v-for="items in item.attrValue" :label="items.attrValueCode" :key="items.attrValueCode">{{items.name}}</el-checkbox>
                        </el-checkbox-group>
                      </el-form-item>
                    </el-col>
                    <template>
                      <el-table :data="tablePriceArray" :span-method="arraySpanMethod" border
                                v-if="tablePriceArray.length>0" style="width: 100%">
                        <el-table-column
                            v-for="(item,i) in atrList"
                            :key='i'
                            :prop="item.key.replace('Code','Name')"
                            :label="item.name">
                        </el-table-column>
                        <el-table-column prop="price" label="价格">
                          <template slot-scope="item">
                            <el-input size="small" v-model.trim="item.row.price" min="0"
                                      onkeyup="this.value= this.value.match(/\d+(\.\d{0,2})?/) ? this.value.match(/\d+(\.\d{0,2})?/)[0] : ''" placeholder="请输商品价格"
                                      type="number">
                              <template slot="append">
                                <span>元</span>
                              </template>
                            </el-input>
                          </template>
                        </el-table-column>
                        <el-table-column prop="price" label="最小价格">
                          <template slot-scope="item">
                            <el-input size="small" v-model.trim="item.row.priceMin" min="0"
                                      onkeyup="this.value= this.value.match(/\d+(\.\d{0,2})?/) ? this.value.match(/\d+(\.\d{0,2})?/)[0] : ''" placeholder="请输商品价格"
                                      type="number">
                              <template slot="append">
                                <span>元</span>
                              </template>
                            </el-input>
                          </template>
                        </el-table-column>
                        <el-table-column prop="price" label="库存">
                          <template slot-scope="item">
                            <el-input-number size="small" :precision='0' :min="0" v-model.trim="item.row.stock"></el-input-number>
                          </template>
                        </el-table-column>
                      </el-table>
                    </template>
                  </div>
                </el-tab-pane>

              </el-tabs>
            </el-col>
          </el-row>

        </el-form>

      </div>
      <div class="modal-footer">
        <el-button v-show="activeStep<3" :loading="loading" type="primary" @click="nextOpen">下一步</el-button>
        <el-button v-show="activeStep==3" :loading="loading" type="primary" @click="confirm()">添加</el-button>
      </div>
    </div>
  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";
import Quill from "@/components/Quill";


export default {
  name: 'Add',
  props:['goodsClassGovValue','goodsClassBusinessValue'],
  data() {
    return {
      loading: false,
      disPrice: true,
      disImg: true,
      disDetails: true,
      loadingModal:false,
      columns:'',
      activeStep:0,
      tablePriceArray:[],
      atrList:[],
      disabledTab:[false,true,true,true],
      tab:'0',
      imageUrl:"",
      addForm:{
        timeStr:timeStr,
        sign:'',
        staffCode:getStaffCode(),
        name:'',
        nameMore:'',
        goodsType:"",
        priceList:[],
        selectAtrValue:{},
        stock:'',
        head1:'',
        head2:'',
        head3:'',
        head4:'',
        head5:'',
        details:'',
        price:'',
        priceMin:'',
        isRecommend:'',
        goodsClassCode:'',
        isBargainPrice:'',
        goodsClassGovernmentCode:'',
        goodsClassBusinessCode:'',
        priceSection:'',
        isAPP:'',
        isPad:'',
      },
      options:{
        value:'goodsClassCode',
        label:'name',
        children:'goodsClassGovernmentList',
        emitPath:false
      },
      options1:{
        value:'goodsClassBusinessCode',
        label:'name',
        children:'secondGoodsClassBusinessList',
        emitPath:false
      },
      rules:{
        name:[
          { required: true, message: '请输入商品名称', trigger: 'blur' }
        ],
        nameMore:[
          { required: true, message: '请输入商品副标题', trigger: 'blur' }
        ],
        goodsType:[
          { required: true, message: '请选择商品类型', trigger: 'blur' }
        ],
        isBargainPrice:[
          { required: true, message: '请选择是否特价', trigger: 'blur' }
        ],
        isRecommend:[
          { required: true, message: '请选择是否推荐', trigger: 'blur' }
        ],
        goodsClassGovernmentCode:[
          { required: true, message: '请选择商品分类', trigger: 'blur' }
        ],
        head1:[
          { required: true, message: '请至少上传一张图片', trigger: 'blur' }
        ],
        price:[
          { required: true, message: '请输入商品价格', trigger: 'blur' }
        ],
        stock:[
          { required: true, message: '请输入商品库存', trigger: 'blur' }
        ],
        details:[
          { required: true, message: '请编辑详情', trigger: 'blur' }
        ],
      },
      status: [{
        value: 0,
        label: '否'
      }, {
        value: 1,
        label: '是'
      }],
      goodsTypeValue: [{
        value: 1,
        label: '普通类'
      }],


    }
  },
  components:{Quill},
  methods: {
    init(){
      this.loading = false;
      this.$refs.addForm.resetFields();
      this.addForm.price='';
      this.addForm.priceMin='';
      this.addForm.goodsClassCode='';
      this.addForm.goodsClassBusinessCode='';
      this.addForm.stock='';
      this.activeStep=0
      this.disabledTab=[false,true,true,true]
      this.tablePriceArray=[]
      this.atrList=[]
      this.addForm.selectAtrValue={}
      this.addForm.priceList=[]
      this.tab='0'
      this.addForm.details='';
      for(var key=0;key<=4;key++){
        this.addForm['head'+(key+1)]=''
      }
    },
    //获取商品分类
    getPriceArray(addGoodsClassCode){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"GoodsAttribute/ListByGoodsClassCode",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          goodsClassCode:addGoodsClassCode
        }
      }).then(
          (response) => {
            if (response.data.error === 0) {
              this.loadingModal=false
              var data=response.data.data
              if(data.length==0){
                this.addForm.price='';
                this.addForm.priceMin='';
                this.addForm.stock='';
                return;
              }
              var list=[]
              for(var i in data){
                var attrValue=''
                let datai=data[i]
                //goods***Code
                let attributeName=datai.code.replace('G','g')
                //goods***List
                let attributeListName=attributeName.replace('Code','List')
                attrValue=JSON.stringify(datai[attributeListName])
                attrValue=attrValue.replace(new RegExp(attributeName,'g'),'attrValueCode')
                attrValue=attrValue.replace(/"status":1/g,'"status":"'+attributeName+'"')
                attrValue=JSON.parse(attrValue)
                this.$set(this.addForm.selectAtrValue,attributeName,[])
                let listvalue={
                  key:attributeName,
                  name:datai.name,
                  attrValue:attrValue,
                }
                list.push(listvalue)
              }
              this.atrList=list
            }else if(response.data.error === 1){
              this.$emit("closeAdd");
              this.$message.error(response.data.message)
            }
          }
      ).catch(function () {
        this.$emit("closeAdd");
        this.$message.error('加载失败')
      });
    },
    keyupEvent(){
      console.log(this.tablePriceArray)
    },
    //获取列表
    fromName(list,index,array,template) {
      var lists=list[index].attrValue
      for(var i in lists){
        let templates={}
        var name=lists[i].status.replace('Code','Name')
        templates[lists[i].status]=lists[i].attrValueCode
        templates[name]=lists[i].name
        var template1=Object.assign(templates,template);
        if(index!=0){
          var arrayList=this.fromName(list,index-1,array,template1)
          array.concat(arrayList)
        }else{
          template1.price=0
          template1.priceMin=0
          template1.stock=0
          array.push(template1)
        }
      }
      return array
    },
    //根据选择获取属性
    selectChangeAtr(){
      var data=this.addForm.selectAtrValue
      var is=true
      for(var i in data){
        if(data[i].length==0){
          is=false
        }
      }
      if(is){
        const atrList=JSON.parse(JSON.stringify(this.atrList));
        var list=this.getAtrList(data,atrList)
        var table=this.fromName(list,list.length-1,[],{})
        this.tablePriceArray=this.getTablePriceArray(table)
        //表格排序
        var key=Object.keys(this.addForm.selectAtrValue)[0].replace('Code','Name')
        this.tablePriceArray.sort(this.compare(key))
      }else{
        this.tablePriceArray=[]
      }
    },
    compare(property) {
      return function (a, b) {
        var value1 = a[property];
        var value2 = b[property];
        return value1.localeCompare(value2);
      }
    },
    getTablePriceArray(table){
      for(var i in table){
        for(var j in this.tablePriceArray){
          if(this.objvequal(table[i],this.tablePriceArray[j])){
            table[i].price=this.tablePriceArray[j].price
            table[i].stock=this.tablePriceArray[j].stock
            table[i].priceMin=this.tablePriceArray[j].priceMin
          }
        }
      }
      return table
    },
    //判读对象是否相等
    objvequal(obj1,obj2){
      for(var i in obj1){
        if(i!='price'&&i!='stock'&&i!='priceMin'){
          if (obj1[i] != obj2[i]) {
            return false;
          }
        }
      }
      return true;
    },
    getAtrList(data,list){
      for(var i in list){
        for (let j = list[i].attrValue.length - 1; j >= 0; j--) {
          var code=list[i].attrValue[j].attrValueCode
          if(data[list[i].key].indexOf(code)==-1){
            list[i].attrValue.splice(j,1);
          }
        }
      }
      return list
    },
    beforeUpload1(file){
      let fd = new FormData();
      fd.append('file',file);//传文件
      fd.append('staffCode',getStaffCode());//传其他参数
      fd.append('timeStr',timeStr);
      fd.append('sign',hex_md5("timeStr=" + timeStr + "&key="+this.$signKey));
      let that = this;
      this.$axios.post(this.$shopUrl+'Upload/Imgs',fd).then(function(res){
        console.log(res.data);
        that.addForm.head1 = that.$imgUrl+res.data.data.path
      })

    },
    goodsClassGovChange(val){
      if(this.addForm.goodsClassCode!=val){
        this.tablePriceArray=[]
        this.atrList=[]
        this.addForm.selectAtrValue=[]
        this.loadingModal=true
        this.getPriceArray(val)
      }
      this.addForm.goodsClassCode=val
    },
    handelIncrease(step) {
      this.addForm.details=step
    },
    nextOpen(){
      var isFalse=true
      switch(this.activeStep){
        case 0:
          this.$refs.addForm.validate((valid) => {
            if(!valid){
              this.$message.warning('请完善基本信息')
              isFalse=false
            }
          })
          break;
        case 1:

          if(!this.addForm.head1){
            this.$message.warning('请至少选择一张图片')
            isFalse=false
          }
          break;
        case 2:
          if(!this.addForm.details){
            this.$message.warning('请编辑商品详情')
            return
          }
          break;
      }
      if(!isFalse)return;
      let index=4
      if(this.tab<index){
        this.activeStep+=1
        this.disabledTab[this.activeStep]=false
        this.tab=this.activeStep.toString()
      }
    },
    beforeUpload2(file){
      let fd = new FormData();
      fd.append('file',file);//传文件
      fd.append('staffCode',getStaffCode());//传其他参数
      fd.append('timeStr',timeStr);
      fd.append('sign',hex_md5("timeStr=" + timeStr + "&key="+this.$signKey));
      let that = this;
      this.$axios.post(this.$shopUrl+'Upload/Imgs',fd).then(function(res){
        console.log(res.data);
        that.addForm.head2 = that.$imgUrl+res.data.data.path
      })

    },
    beforeUpload3(file){
      let fd = new FormData();
      fd.append('file',file);//传文件
      fd.append('staffCode',getStaffCode());//传其他参数
      fd.append('timeStr',timeStr);
      fd.append('sign',hex_md5("timeStr=" + timeStr + "&key="+this.$signKey));
      let that = this;
      this.$axios.post(this.$shopUrl+'Upload/Imgs',fd).then(function(res){
        console.log(res.data);
        that.addForm.head3 = that.$imgUrl+res.data.data.path
      })

    },
    beforeUpload4(file){
      let fd = new FormData();
      fd.append('file',file);//传文件
      fd.append('staffCode',getStaffCode());//传其他参数
      fd.append('timeStr',timeStr);
      fd.append('sign',hex_md5("timeStr=" + timeStr + "&key="+this.$signKey));
      let that = this;
      this.$axios.post(this.$shopUrl+'Upload/Imgs',fd).then(function(res){
        console.log(res.data);
        that.addForm.head4 = that.$imgUrl+res.data.data.path
      })

    },
    beforeUpload5(file){
      let fd = new FormData();
      fd.append('file',file);//传文件
      fd.append('staffCode',getStaffCode());//传其他参数
      fd.append('timeStr',timeStr);
      fd.append('sign',hex_md5("timeStr=" + timeStr + "&key="+this.$signKey));

      let that = this;
      this.$axios.post(this.$shopUrl+'Upload/Imgs',fd).then(function(res){
        console.log(res.data);
        that.addForm.head5 = that.$imgUrl+res.data.data.path
      })

    },
    removeHead() {

      this.$prompt('输入删除第几个主图', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({ value }) => {

        if(value == 1){
          this.addForm.head1 = '';
        }
        if(value == 2){
          this.addForm.head2 = '';
        }
        if(value == 3){
          this.addForm.head3 = '';
        }
        if(value == 4){
          this.addForm.head4 = '';
        }
        if(value == 5){
          this.addForm.head5 = '';
        }


      }).catch(() => {

        this.$message({
          type: 'info',
          message: '取消输入'
        });

      });


    },
    closeSelf() {
      this.$emit("closeAdd");
      // this.loadingModal=true
    },

    confirm(){
      this.$refs.addForm.validate((valid) => {
        if(!valid){
          this.$message.warning('请完善基本信息')
          return
        }
      })
      if(!this.addForm.head1){
        this.$message.warning('请至少选择一张图片')
        return
      }
      if(!this.addForm.details){
        this.$message.warning('请编辑商品详情')
        return
      }
      if(this.atrList.length>0){
        if(this.tablePriceArray.length==0){
          this.$message.warning('请选择完整的商品属性')
          return;
        }
        for(var i in this.tablePriceArray){
          if(this.tablePriceArray[i].price==0){
            this.$message.warning('请完善商品价格')
            return;
          }
        }
      }else{
        if(!this.addForm.price){
          this.$message.warning('请填写商品价格')
          return;
        }
        if(!this.addForm.stock){
          this.$message.warning('请填写商品库存')
          return;
        }
      }
      this.addSubmit();
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      this.columns=column
      var key=Object.keys(this.addForm.selectAtrValue)[0]
      if (columnIndex === 0) {
        if(rowIndex ===0 || row[key] != this.tablePriceArray[rowIndex-1][key]){
          let rowspan = 0;
          this.tablePriceArray.forEach(element => {
            if(element[key] === row[key]){
              rowspan ++;
            }
          });
          return [rowspan, 1];
        }else {
          return [0, 0];
        }
      }
    },
    addSubmit(){
      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
      this.addForm.head1=this.addForm.head1.replace(this.$imgUrl,'')
      if(this.addForm.head2){
        this.addForm.head2=this.addForm.head2.replace(this.$imgUrl,'')
      }
      if(this.addForm.head3){
        this.addForm.head3=this.addForm.head3.replace(this.$imgUrl,'')
      }
      if(this.addForm.head4){
        this.addForm.head4=this.addForm.head4.replace(this.$imgUrl,'')
      }
      if(this.addForm.head5){
        this.addForm.head5=this.addForm.head5.replace(this.$imgUrl,'')
      }
      if(!this.addForm.stock){
        this.addForm.stock=0
      }
      if(!this.addForm.priceMin){
        this.addForm.priceMin=0
      }
      this.addForm.priceList=this.tablePriceArray

      if(this.atrList.length==0){
        this.addForm.priceList=[{goodsColorCode:'',goodsSizeCode:'',stock:this.addForm.stock,price:this.addForm.price}]
        this.addForm.priceSection=this.addForm.price
      }else{
        this.tablePriceArray.sort(function(a,b){
          return a.price-b.price
        })
        this.addForm.priceSection=this.tablePriceArray[0].price+'~'+this.tablePriceArray[this.tablePriceArray.length-1].price
      }
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Goods/AddJiFen",
        data: this.addForm
      }).then(
          (response) => {
            this.loading = false;
            if (response.data.error == 0) {
              this.$emit("closeAdd");
              // this.loadingModal=true
              this.$emit("getList");
            }else if(response.data.error == 1){
              this.$message.error(response.data.message)
            }
          }
      )
    },
  }
}


</script>





<style lang="scss" scoped>

.modal-goodsAdd {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0,0,0,.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;

  overflow-y: auto;


  .modal {
    background-color: #fff;
    box-shadow:  0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    overflow-x:auto;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    width: 1000px;

    margin: 50px 0px;

    .imgLabel /deep/ .el-form-item__content{
      margin-top: 40px;
    }
    .modal-body .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      width:80px;
      height: 80px;
    }
    .modal-body  .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .modal-body   .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 80px;
      height: 80px;
      line-height: 80px;
      text-align: center;
    }
    .modal-body .avatar {
      width: 80px;
      height: 80px;
      display: block;
    }
    /deep/ .el-tabs .el-tabs__content{
      height: 100%;
      overflow: auto;
    }

    .modal-header {
      border-bottom: 1px solid #eee;
      color: #313131;
      justify-content: space-between;
      padding: 10px;
      display: flex;
    }
    .modal-body {
      position: relative;
      padding: 20px 0px;
      z-index: 99;
      overflow-y:auto;
      height:400px;
    }
    .modal-footer {
      border-top: 1px solid #eee;
      justify-content: flex-end;
      padding: 15px;
      display: flex;
    }


  }

}

.avatar-uploader /deep/ .el-upload--picture-card{
  width: 80px;
  height: 80px;
  line-height: 90px;
}
.btn-close, .btn-confirm {
  border-radius: 8px;
  margin-left:16px;
  width:56px;
  height: 36px;
  border:none;
  cursor: pointer;
}
.btn-close {
  color: #313131;
  background-color:transparent;
}



.row{
  padding: 10px 0px;
}
.item{
  padding: 0px 20px;
}
.label{
  padding: 5px 0px;
}


</style>
